import React from 'react';
import { Logo } from 'stateful-ui/src';
import { Container, Content } from './styles';

export const Header = () => {
  return (
    <Container>
      <Content>
        <Logo />
      </Content>
    </Container>
  );
};
